import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import Header from '../../components/ui/Header';




// Import user profile components
import ProfileHeader from './components/ProfileHeader';
import MatchHistory from './components/MatchHistory';
import SocialSection from './components/SocialSection';
import AccountSettings from './components/AccountSettings';
import AchievementShowcase from './components/AchievementShowcase';
import StatisticsVisualization from './components/StatisticsVisualization';
import ProfileCustomization from './components/ProfileCustomization';

const UserProfile = () => {
  const [userData, setUserData] = useState({});
  const [matchHistory, setMatchHistory] = useState([]);
  const [friends, setFriends] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [statistics, setStatistics] = useState({});
  const [activities, setActivities] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('profile');
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();

  // Tabs for mobile navigation
  const tabs = [
  { id: 'profile', label: 'Perfil', icon: 'User' },
  { id: 'matches', label: 'Partidas', icon: 'Calendar' },
  { id: 'social', label: 'Social', icon: 'Users' },
  { id: 'achievements', label: 'Conquistas', icon: 'Award' },
  { id: 'settings', label: 'Configurações', icon: 'Settings' },
  { id: 'statistics', label: 'Estatísticas', icon: 'BarChart' }];


  // Mock data initialization
  useEffect(() => {
    const initializeProfile = () => {
      // Mock user data
      const mockUser = {
        id: 1,
        name: 'João Silva',
        avatar: "https://images.unsplash.com/photo-1641479160067-5ae7bde244b0",
        avatarAlt: 'Professional headshot of young man with short brown hair in casual shirt',
        location: 'São Paulo, SP',
        bio: 'Apaixonado por futebol desde criança. Organizador de peladas de fim de semana. Sempre pontual e pagador em dia! ⚽',
        skillLevel: 'Intermediário',
        preferredPositions: ['Meio-campo', 'Atacante'],
        joinDate: '2024-01-15',
        reputation: 4.7,
        totalMatches: 67,
        wins: 42,
        goals: 89,
        assists: 34,
        badges: 12,
        streak: 5,
        phone: '+55 11 99999-9999',
        email: 'joao.silva@email.com',
        pixKey: 'joao.silva@email.com',
        notifications: {
          matches: true,
          payments: true,
          social: false,
          marketing: false
        },
        privacy: {
          showPhone: false,
          showEmail: true,
          showStats: true,
          allowInvites: true
        }
      };

      // Mock match history
      const mockMatches = [
      {
        id: 1,
        title: 'Pelada de Sábado',
        venue: 'Campo do Morumbi',
        date: '2025-10-12',
        time: '14:00',
        result: 'win',
        score: '3-2',
        userGoals: 2,
        userAssists: 1,
        attendance: 'confirmed',
        payment: 'paid',
        photos: [
        {
          url: "https://images.unsplash.com/photo-1441092380326-e82d14ad9446",
          alt: 'Group photo of players on football field after match'
        },
        {
          url: "https://images.unsplash.com/photo-1617051283949-54706dbf6bab",
          alt: 'Action shot of players during football match'
        }]

      },
      {
        id: 2,
        title: 'Racha de Domingo',
        venue: 'Quadra da Vila',
        date: '2025-10-06',
        time: '16:00',
        result: 'loss',
        score: '1-2',
        userGoals: 0,
        userAssists: 1,
        attendance: 'confirmed',
        payment: 'paid'
      },
      {
        id: 3,
        title: 'Copa dos Amigos',
        venue: 'Arena Central',
        date: '2025-09-29',
        time: '15:00',
        result: 'win',
        score: '4-1',
        userGoals: 1,
        userAssists: 2,
        attendance: 'confirmed',
        payment: 'paid'
      }];


      // Mock friends
      const mockFriends = [
      {
        id: 1,
        name: 'Pedro Santos',
        avatar: "https://images.unsplash.com/photo-1667575949231-fbf430640797",
        avatarAlt: 'Professional headshot of man with beard in blue shirt',
        status: 'online',
        mutualMatches: 23,
        lastSeen: new Date()
      },
      {
        id: 2,
        name: 'Carlos Lima',
        avatar: "https://images.unsplash.com/photo-1723607528434-21cde67167c4",
        avatarAlt: 'Professional headshot of man with glasses in white shirt',
        status: 'offline',
        mutualMatches: 15,
        lastSeen: new Date(Date.now() - 3600000)
      },
      {
        id: 3,
        name: 'Ana Costa',
        avatar: "https://images.unsplash.com/photo-1628013663808-25ef6a3b28b4",
        avatarAlt: 'Professional headshot of woman with long brown hair in business attire',
        status: 'online',
        mutualMatches: 8,
        lastSeen: new Date()
      }];


      // Mock achievements
      const mockAchievements = [
      {
        id: 1,
        title: 'Pontualidade',
        description: 'Chegou no horário em 10 peladas seguidas',
        type: 'attendance',
        earnedAt: '2025-10-01',
        rarity: 'common',
        progress: 100
      },
      {
        id: 2,
        title: 'Artilheiro',
        description: 'Marcou 5 gols em uma única partida',
        type: 'performance',
        earnedAt: '2025-09-15',
        rarity: 'rare',
        progress: 100
      },
      {
        id: 3,
        title: 'Organizador Master',
        description: 'Criou 25 peladas',
        type: 'organizer',
        earnedAt: '2025-08-20',
        rarity: 'epic',
        progress: 100
      },
      {
        id: 4,
        title: 'Sequência de Ouro',
        description: 'Ganhou 5 partidas seguidas',
        type: 'streak',
        earnedAt: '2025-07-10',
        rarity: 'legendary',
        progress: 100
      },
      {
        id: 5,
        title: 'Social',
        description: 'Adicionou 20 amigos',
        type: 'social',
        earnedAt: '2025-06-05',
        rarity: 'uncommon',
        progress: 100
      },
      {
        id: 6,
        title: 'Combo Master',
        description: 'Marque 10 gols e dê 10 assistências',
        type: 'performance',
        earnedAt: null,
        rarity: 'rare',
        progress: 75,
        currentGoals: 7,
        targetGoals: 10,
        currentAssists: 8,
        targetAssists: 10
      }];


      // Mock statistics
      const mockStatistics = {
        monthly: {
          labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out'],
          matches: [2, 3, 4, 2, 5, 3, 6, 4, 5, 2],
          wins: [1, 2, 3, 1, 3, 2, 4, 3, 3, 2],
          goals: [3, 5, 8, 2, 9, 6, 12, 7, 10, 4]
        },
        venues: [
        { name: 'Campo do Morumbi', matches: 15, wins: 10 },
        { name: 'Arena Central', matches: 12, wins: 8 },
        { name: 'Quadra da Vila', matches: 10, wins: 6 },
        { name: 'Futebol Clube', matches: 8, wins: 5 }],

        positions: {
          'Atacante': 35,
          'Meio-campo': 25,
          'Lateral': 5,
          'Zagueiro': 2
        },
        weeklyActivity: [
        { day: 'Dom', matches: 8 },
        { day: 'Seg', matches: 2 },
        { day: 'Ter', matches: 5 },
        { day: 'Qua', matches: 3 },
        { day: 'Qui', matches: 4 },
        { day: 'Sex', matches: 7 },
        { day: 'Sab', matches: 12 }]

      };

      // Mock recent activities
      const mockActivities = [
      {
        id: 1,
        type: 'match_result',
        title: 'Vitória na pelada',
        description: 'Ganhou 3-2 no Campo do Morumbi com 2 gols',
        timestamp: new Date(Date.now() - 86400000),
        metadata: { goals: 2, assists: 1 }
      },
      {
        id: 2,
        type: 'achievement',
        title: 'Nova conquista',
        description: 'Desbloqueou o badge "Pontualidade"',
        timestamp: new Date(Date.now() - 172800000)
      },
      {
        id: 3,
        type: 'friend_added',
        title: 'Novo amigo',
        description: 'Ana Costa foi adicionada aos seus amigos',
        timestamp: new Date(Date.now() - 259200000),
        friend: {
          name: 'Ana Costa',
          avatar: "https://images.unsplash.com/photo-1628013663808-25ef6a3b28b4",
          avatarAlt: 'Professional headshot of woman with long brown hair in business attire'
        }
      }];


      // Mock photos
      const mockPhotos = [
      {
        id: 1,
        url: "https://images.unsplash.com/photo-1441092380326-e82d14ad9446",
        alt: 'Group photo of players on football field after match',
        event: 'Pelada de Sábado',
        date: '2025-10-12'
      },
      {
        id: 2,
        url: "https://images.unsplash.com/photo-1617051283949-54706dbf6bab",
        alt: 'Action shot of players during football match',
        event: 'Copa dos Amigos',
        date: '2025-09-29'
      },
      {
        id: 3,
        url: "https://images.unsplash.com/photo-1710789020364-a76c9517ea7e",
        alt: 'Team celebrating goal during football match',
        event: 'Churrasco pós-jogo',
        date: '2025-09-15'
      }];


      setUserData(mockUser);
      setMatchHistory(mockMatches);
      setFriends(mockFriends);
      setAchievements(mockAchievements);
      setStatistics(mockStatistics);
      setActivities(mockActivities);
      setPhotos(mockPhotos);
      setIsLoading(false);
    };

    const timer = setTimeout(initializeProfile, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setEditMode(false);
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
  };

  const handleProfileUpdate = (updatedData) => {
    setUserData((prev) => ({ ...prev, ...updatedData }));
    setEditMode(false);
  };

  const handleSettingsUpdate = (updatedSettings) => {
    setUserData((prev) => ({
      ...prev,
      notifications: { ...prev?.notifications, ...updatedSettings?.notifications },
      privacy: { ...prev?.privacy, ...updatedSettings?.privacy }
    }));
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="animate-pulse space-y-6">
            <div className="flex items-center space-x-4">
              <div className="w-24 h-24 bg-muted rounded-full"></div>
              <div className="space-y-2">
                <div className="h-6 bg-muted rounded w-32"></div>
                <div className="h-4 bg-muted rounded w-24"></div>
                <div className="h-4 bg-muted rounded w-40"></div>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 space-y-6">
                <div className="h-64 bg-muted rounded-lg"></div>
                <div className="h-48 bg-muted rounded-lg"></div>
              </div>
              <div className="space-y-6">
                <div className="h-80 bg-muted rounded-lg"></div>
                <div className="h-64 bg-muted rounded-lg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>);

  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-6">
        {/* Mobile Tab Navigation */}
        <div className="lg:hidden mb-6">
          <div className="flex space-x-1 overflow-x-auto pb-2">
            {tabs?.map((tab) =>
            <button
              key={tab?.id}
              onClick={() => handleTabChange(tab?.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-standard ${
              activeTab === tab?.id ?
              'bg-primary text-primary-foreground' :
              'bg-muted text-muted-foreground hover:text-foreground hover:bg-muted/70'}`
              }>

                <Icon name={tab?.icon} size={16} />
                <span>{tab?.label}</span>
              </button>
            )}
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left Column - Profile Info */}
            <div className="space-y-6">
              <ProfileHeader
                userData={userData}
                editMode={editMode}
                onEditToggle={handleEditToggle}
                onProfileUpdate={handleProfileUpdate} />

              
              <SocialSection
                friends={friends}
                activities={activities}
                photos={photos}
                onNavigate={navigate} />

            </div>

            {/* Middle Column - Main Content */}
            <div className="space-y-6">
              <MatchHistory
                matches={matchHistory}
                onNavigate={navigate} />

              
              <StatisticsVisualization
                statistics={statistics}
                userData={userData} />

            </div>

            {/* Right Column - Achievements & Settings */}
            <div className="space-y-6">
              <AchievementShowcase
                achievements={achievements}
                userData={userData} />

              
              <AccountSettings
                userData={userData}
                onSettingsUpdate={handleSettingsUpdate} />

              
              <ProfileCustomization
                userData={userData}
                onProfileUpdate={handleProfileUpdate} />

            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          {activeTab === 'profile' &&
          <div className="space-y-6">
              <ProfileHeader
              userData={userData}
              editMode={editMode}
              onEditToggle={handleEditToggle}
              onProfileUpdate={handleProfileUpdate} />

              <ProfileCustomization
              userData={userData}
              onProfileUpdate={handleProfileUpdate} />

            </div>
          }
          
          {activeTab === 'matches' &&
          <div className="space-y-6">
              <MatchHistory
              matches={matchHistory}
              onNavigate={navigate} />

              <StatisticsVisualization
              statistics={statistics}
              userData={userData} />

            </div>
          }
          
          {activeTab === 'social' &&
          <SocialSection
            friends={friends}
            activities={activities}
            photos={photos}
            onNavigate={navigate} />

          }
          
          {activeTab === 'achievements' &&
          <AchievementShowcase
            achievements={achievements}
            userData={userData} />

          }
          
          {activeTab === 'settings' &&
          <AccountSettings
            userData={userData}
            onSettingsUpdate={handleSettingsUpdate} />

          }
          
          {activeTab === 'statistics' &&
          <StatisticsVisualization
            statistics={statistics}
            userData={userData} />

          }
        </div>
      </main>
    </div>);

};

export default UserProfile;